




























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import API from '@/plugins/axios';
import { dateSort } from '@/utils/utils';
import dayjs from 'dayjs';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import Axios from 'axios';
import ReportBarChart from '@/components/ReportBarChart.vue';
import { characteristicsReport, templateReport } from '@/utils/reportData';
import { characteristics, criteria, template, vocationalQualifications } from '@/utils/data';
import LineChart from '@/components/LineChart.vue';
import BarChart from '@/components/BarChart.vue';

export default Vue.extend({
  name: 'Home',
  components: { BarChart, LineChart, ReportBarChart },
  data: () => ({
    personalData: {},
    applications: [],
    applicationObj: {
      candidate: {},
      questioner: {},
    },

    characteristics: [...characteristics],
    template: [...template],
    criteria: [...criteria],
    vocational_qualifications: [...vocationalQualifications],
    charBarChart: true,
    tempBarChart: true,
    criteriaBarChart: false,

    headers: [
      { text: 'Kompanija', value: 'company_name' },
      { text: 'Kampanja', value: 'position' },
      { text: 'Datum', value: 'created_at', sort: dateSort },
      { text: 'Status', value: 'state' },
      { text: 'Akcija', value: 'actions', sortable: false },
      { text: 'Preuzmi', value: 'download', sortable: false },
    ],
    isTestStarted: false,
    isTestDone: false,
    allDataIn: false,
    isTestOlder: false,
    psych: {
      forename: 'Nenad',
      surname: 'Mitrovic',
      contact_phone: '011123456',
      title: 'CEO',
      email: 'nenadmitrovic@psiholog.local',
    },
    applicationsPlus: [
      {
        id: 0,
        questioner: {
          id: 196,
          personality: {
            id: 169,
            IST: 68,
            PRO: 100,
            ODG: 56,
            INO: 96,
            EFI: 80,
            VK: 80,
            SAR: 72,
            IST_perc: 10,
            PRO_perc: 22,
            ODG_perc: 7,
            INO_perc: 29,
            EFI_perc: 6,
            VK_perc: 6,
            SAR_perc: 9,
            questioner: 196,
          },
          decisions: {
            id: 168,
            brzina: 8,
            preuzimanje: 8,
            samostalnost: 8,
            informisanost: 8,
            prakticnost: 8,
            objektivnost: 8,
            eticnost: 8,
            rizik: 8,
            originalnost: 8,
            dvoumljenje: 8,
            tezina: 8,
            voljnost: 8,
            socijalna: 8,
            emocionalnost: 8,
            kvalitet: 8,
            racionalnost: 8,
            planiranje: 8,
            koriscenje: 8,
            brzina_perc: 55,
            preuzimanje_perc: 20,
            samostalnost_perc: 15,
            informisanost_perc: 35,
            prakticnost_perc: 55,
            objektivnost_perc: 60,
            eticnost_perc: 30,
            rizik_perc: 30,
            originalnost_perc: 55,
            dvoumljenje_perc: 50,
            tezina_perc: 60,
            voljnost_perc: 25,
            socijalna_perc: 35,
            emocionalnost_perc: 50,
            kvalitet_perc: 70,
            racionalnost_perc: 55,
            planiranje_perc: 25,
            koriscenje_perc: 35,
            questioner: 196,
          },
          dimensions: {
            id: 168,
            promisljenost: 32,
            pragmaticnost: 23,
            racionalnost: 29,
            sistematicnost: 18,
            preduzimljivost: 10,
            analiticnost: 10,
            promisljenost_perc: 7,
            pragmaticnost_perc: 40,
            racionalnost_perc: 25,
            sistematicnost_perc: 20,
            preduzimljivost_perc: 20,
            analiticnost_perc: 40,
            questioner: 196,
          },
          created_at: '2025-11-06T12:42:19.765548Z',
          updated_at: '2025-11-06T12:47:00.177796Z',
          finished_at: '2025-11-06T12:47:00.177775Z',
          questions_list:
            '["ODG-13", "PRO-5", "ODG-9", "EFI-17", "VK-18", "IST-8", "PODO-17", "PODO-24", "ODG-12", "INO-1", "IST-17", "PRO-11", "PRO-8", "INO-3", "PRO-13", "INO-15", "PRO-15", "PRO-1", "PRO-12", "IST-3", "VK-4", "PRO-24", "VK-13", "SAR-10", "SAR-14", "VK-12", "ODG-14", "PODO-22", "VK-3", "PODO-16", "SAR-8", "PRO-3", "EFI-9", "INO-23", "PODO-2", "IST-1", "ODG-5", "INO-4", "VK-20", "EFI-20", "VK-14", "INO-11", "EFI-1", "VK-9", "PODO-13", "EFI-19", "PRO-10", "SAR-16", "VK-19", "EFI-10", "SAR-3", "PODO-32", "ODG-7", "SAR-18", "IST-9", "SAR-1", "INO-6", "PODO-25", "PRO-23", "PODO-36", "PODO-6", "ODG-8", "EFI-16", "PRO-19", "PODO-4", "VK-11", "PODO-3", "VK-2", "INO-19", "SAR-11", "INO-5", "ODG-2", "PRO-25", "IST-4", "PODO-18", "SAR-2", "PODO-27", "IST-11", "IST-16", "PRO-4", "PODO-9", "PODO-35", "IST-12", "SAR-12", "VK-17", "VK-7", "PODO-7", "PODO-26", "SAR-6", "EFI-13", "ODG-11", "PODO-34", "SAR-13", "EFI-8", "INO-2", "ODG-10", "INO-20", "EFI-14", "IST-10", "SAR-7", "EFI-15", "INO-9", "EFI-12", "IST-6", "PRO-21", "PODO-10", "PODO-21", "VK-5", "INO-14", "VK-16", "IST-2", "IST-15", "EFI-11", "EFI-4", "PODO-12", "PODO-31", "PODO-15", "SAR-4", "PODO-33", "PODO-11", "PODO-1", "PODO-28", "INO-10", "ODG-3", "IST-13", "PRO-7", "EFI-18", "VK-6", "INO-24", "PRO-17", "INO-21", "SAR-17", "IST-5", "PODO-5", "INO-7", "INO-13", "VK-1", "EFI-7", "ODG-1", "INO-22", "PODO-14", "VK-15", "SAR-5", "EFI-2", "EFI-5", "INO-16", "EFI-6", "PRO-18", "PRO-9", "INO-12", "PRO-20", "PODO-23", "ODG-6", "SAR-15", "SAR-9", "IST-7", "ODG-4", "EFI-3", "IST-14", "INO-18", "PRO-14", "PRO-2", "PODO-30", "PRO-16", "INO-8", "INO-17", "PODO-20", "VK-10", "PRO-22", "PODO-19", "VK-8", "PRO-6", "PODO-8", "PODO-29"]',
          per_page: 4,
          current_page: 1,
          is_finished: true,
          total_seconds: 270,
          candidate: 458,
        },
        candidate: {
          created_at: '2025-11-03T10:04:18.019157Z',
          updated_at: '2025-11-03T10:04:46.919673Z',
          forename: 'aefwefw',
          surname: 'wefwef',
          birth_year: '1987-01-01',
          gender: 'M',
          education_level: 'Osnovno obrazovanje i vaspitanje',
          vocation: 'wefwef',
          parent_name: 'wefwef',
          last_education: 'wefwef',
          contact_phone: '23452523',
          id_card_no: '1',
          email: 'beowolfpro@gmail.com',
        },
        conclusion: null,
      },
    ],
    campaign: {
      position: 'Karijerno vodjenje - Cultural Fit',
      state: 'ready',
      campaign_type: 'new_position',
      starts_at: '2024-11-06',
      ends_at: '2025-06-01',
      num_reports: 5000,
      num_candidates: 5000,
      company: {
        id: 13,
        name: 'SciEd Technologies',
        apr_id: '21210439',
        pib: '109611790',
        contact_name: 'SciEd',
        contact_phone: '062295275',
        contact_email: 'sciedtechnologies@gmail.com',
        created_at: '2024-11-07T22:47:31.517184Z',
        updated_at: '2024-11-07T22:49:04.698407Z',
        logo: null,
        location: 'Beograd',
      },
      created_at: '2024-11-07T22:49:59.650303Z',
      updated_at: '2025-11-06T12:47:03.808804Z',
      url: '3b535280-9100-4b8e-86a9-ed26dddbc3ef',
      id: 65,
      num_submitted: 1,
      test_type: ['Inovativnost', 'Proaktivnost', 'Istrajnost', 'Odgovornost', 'Veština komunikacije', 'Efikasnost'],
      males_percent: 400,
    },
  }),
  computed: {
    ...mapGetters(['userData', 'questioners']),
    contextPages(): number {
      return Math.ceil(this.applicationsPlus.length / 20);
    },
    numberOfPages(): number {
      return (
        3 +
        (this as any).contextPages +
        this.applicationsPlus.reduce((prev: number, next: { conclusion: unknown }) => {
          return prev + 2 + (next.conclusion ? 1 : 0);
        }, 0)
      );
    },
    applicationsContext(): any[] {
      const pages = [] as any[];
      for (let i = 0; i < Math.ceil(this.applicationsPlus.length / 20); i++) {
        pages.push(this.applicationsPlus.slice(i * 20, (i + 1) * 20));
      }
      return pages;
    },
    applicationPageStart() {
      return this.applicationsPlus.reduce(
        (
          prev: {
            candidates: {
              [key: string]: number;
            };
            lastPage: number;
          },
          next: { conclusion: unknown; id: number }
        ) => {
          prev.candidates[next.id] = prev.lastPage + 1;
          prev.lastPage = prev.lastPage + 2 + (next.conclusion ? 1 : 0);
          return prev;
        },
        {
          candidates: {},
          lastPage: 3 + (this as any).contextPages,
        }
      );
    },

    charChartData() {
      const labels = this.characteristics.map(c => c.name);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const app = this.applicationObj as any;
      return {
        labels,
        datasets: [
          Object.keys(app.candidate).length
            ? {
                label: `${app.candidate.forename} ${app.candidate.surname}`,
                backgroundColor: '#E74C3C',
                borderColor: '#E74C3C',
                fill: false,
                lineTension: 0,
                minBarLength: 2,
                data: Object.entries(app.questioner.personality)
                  .map(([key, value]) => {
                    return key.includes('_perc') && value;
                  })
                  .filter(v => !!v),
              }
            : {},
        ],
      };
    },
    tempChartData() {
      const labels = this.template.map(c => c.name);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const app = this.applicationObj as any;
      return {
        labels,
        datasets: [
          Object.keys(app.candidate).length
            ? {
                label: `${app.candidate.forename} ${app.candidate.surname}`,
                backgroundColor: '#16A085',
                borderColor: '#16A085',
                fill: false,
                lineTension: 0,
                minBarLength: 2,
                data: Object.entries(app.questioner.dimensions)
                  .map(([key, value]) => {
                    return key.includes('_perc') && value;
                  })
                  .filter(v => !!v),
              }
            : {},
        ],
      };
    },
    criteriaChartData() {
      const labels = this.criteria.map(c => c.name);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const app = this.applicationObj as any;

      return {
        labels,
        datasets: [
          Object.keys(app.candidate).length
            ? {
                label: `${app.candidate.forename} ${app.candidate.surname}`,
                backgroundColor: '#9B59B6',
                borderColor: '#9B59B6',
                fill: false,
                lineTension: 0,
                minBarLength: 2,
                data: Object.entries(app.questioner.decisions)
                  .map(([key, value]) => {
                    return key.includes('_perc') && value;
                  })
                  .filter(v => !!v),
              }
            : {},
        ],
      };
    },
    chartOptions() {
      return {
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                min: 0,
              },
            },
          ],
        },
      };
    },
  },
  methods: {
    convertDate(date: string) {
      return dayjs(date).format('DD.MM.YYYY.');
    },
    async dlReport(print = false) {
      const reportBody = document.getElementById('reportBody');
      const links = Array.from(document.querySelectorAll('link'))
        .filter(l => l.href.includes('.css'))
        .map(l => l.href);

      const data = await Promise.all(links.map(async l => (await Axios.get(l)).data));
      const report = `
<html id="innerHTML">
    <head>
        <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
        <meta name="pdfkit-page-size" content="A4"/>
        <meta name="pdfkit-margin-bottom" content="0"/>
        <meta name="pdfkit-margin-left" content="0"/>
        <meta name="pdfkit-margin-right" content="0"/>
        <meta name="pdfkit-margin-top" content="0"/>
        <meta name="pdfkit-orientation" content="Portrait"/>
        <style>
            ${data.join(' ')}
        </style>
        <style>
            ${Array.from(document.querySelectorAll('style'))
              .map(s => s.innerHTML)
              .join(' ')}
        </style>
        <style>
            @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap');
            body { zoom: 120%; }
            html, body {
            font-family: 'Roboto', sans-serif;
            }
            @page {
            margin: 10%;

            @top-center {
            font-family: sans-serif;
            font-weight: bold;
            font-size: 2em;
            content: counter(page);
            }
            }
            .reportPage {
            display: block !important;
            }
        </style>
    </head>
    <body class="reportPage">
        ${reportBody?.outerHTML as string}
    </body>
</html>
`;
      const blob = new Blob([report], { type: 'text/html;charset=utf-8' });
      const form = new FormData();
      form.append('filename', 'file');
      form.append('report', blob);
      const { request } = await API.post('/psych/reports/generate/', form, {
        responseType: 'blob',
      });
      const filename = `izvestaj.pdf`;

      // The actual download
      const newBlob = new Blob([request.response], { type: 'application/pdf' });
      const href = window.URL.createObjectURL(newBlob);
      if (!print) {
        const link = document.createElement('a');
        link.href = href;
        link.download = filename;

        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
      } else {
        window.open(href, '_blank');
      }
    },
    characteristicsData(application: { questioner: { personality: { [key: string]: number } } }) {
      const personality = application.questioner.personality;
      const data = [] as {}[];
      Object.entries(characteristicsReport).forEach(([key, values]) => {
        const percent = personality[`${key}_perc`];
        const title = characteristics.find(c => c.key === key)?.name;
        let score = '';
        let scoreDesc = '';
        let to = '';
        let text = '';

        Object.keys(values).forEach(key => {
          if (percent > Number(key)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const val = values as any;
            score = val[key].title;
            to = val[key].to;
            scoreDesc = `${key} - ${val[key].to}%`;
            text = val[key].text;
          }
        });

        data.push({
          title,
          score,
          scoreDesc,
          to,
          text,
        });
      });
      return data;
    },
    templateData(application: { questioner: { dimensions: { [key: string]: number } } }) {
      const dimensions = application.questioner.dimensions;
      const data = [] as {}[];
      Object.entries(templateReport).forEach(([key, values]) => {
        const percent = dimensions[`${key}_perc`];
        const title = template.find(c => c.key === key)?.name;
        let score = '';
        let to = '';
        let text = '';

        Object.keys(values).forEach(key => {
          if (percent > Number(key)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            score = (values as any)[key].title;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            to = (values as any)[key].to;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            text = (values as any)[key].text;
          }
        });

        data.push({
          title,
          score,
          to,
          text,
        });
      });
      return data;
    },
    formatedDate(date: string) {
      return dayjs(date).format('DD/MM/YY');
    },
    async resend() {
      await API.get('/auth/resend_verification/');
    },
    async getQuestioners() {
      try {
        const { data } = await API.get('candidate/questioners/');
        this.$store.dispatch('setQuestioners', data);
        const qIds = this.applications.reduce((prev, next: any) => {
          if (next.campaign_type == 'company_profile') {
            prev.push(next.questioner_id);
          }
          return prev;
        }, [] as number[]);
        const notCompanyQuestionnaires = data.filter((q: { id: number }) => !qIds.includes(q.id));
        const hasUnfinished = notCompanyQuestionnaires.some((q: { is_finished: boolean }) => q.is_finished === false);
        const hasAny = notCompanyQuestionnaires.length > 0;

        this.isTestStarted = hasUnfinished;
        this.isTestDone = hasAny && !hasUnfinished;

        const finishedAt = notCompanyQuestionnaires[0]?.finished_at as string | undefined;
        this.isTestOlder = !this.isTestStarted && this.isTestDone && dayjs(finishedAt) <= dayjs().subtract(6, 'month');
      } catch (e) {
        console.error(e);
      }
    },
    async submitQuestioner(application_id: number) {
      const q = this.questioners.find((q: { is_finished: boolean }) => q.is_finished);
      const application = this.applications.find((a: { id: number }) => a.id === application_id);
      if (application && (application as { campaign_type: string }).campaign_type == 'company_profile') {
        await this.$router.push(`/test/${application_id}/new`);
      } else if (!this.isTestOlder) {
        await API.patch(`candidate/applications/${application_id}/submit/`, {
          questioner_id: q.id,
        });
        this.$router.push('/test/application_sent');
      } else {
        this.$router.push(`/test/${application_id}/submit_or_new`);
      }
    },
  },
  async mounted() {
    const { data, status } = await API.get('/candidate/self/');
    if (status === 200) {
      await this.$store.dispatch('setUserData', {
        verified: true,
      });
      const { applications, ...allData } = data;
      this.personalData = { ...allData };
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.applications = applications.map((a: any) => ({
        id: a.id,
        created_at: a.created_at,
        is_completed: a.is_completed,
        state: a.campaign.state,
        questioner_id: a.questioner_id,
        position: a.position,
        company_name: a.campaign.company.name,
        campaign_type: a.campaign.campaign_type,
      }));

      const { data: applicationData } = await API.get(`/psych/applications/${applications[0].id}/`);
      this.applicationObj = applicationData;

      const { data: printPDFData } = await API.get(`/psych/applications/${applications[0].id}/campaign/`);
      this.campaign = printPDFData.campaign;
      this.applicationsPlus = [{ ...printPDFData }];
      this.allDataIn = true;
      await this.$nextTick();

      await (this as any).getQuestioners();

      if (localStorage.getItem('justVerified') === 'true') {
        localStorage.removeItem('justVerified');
        this.$root.$emit('snackbarCreate', {
          success: true,
          title: 'Email Verifikovan',
          text: 'Bravo! Sada možete da uradite test.',
        });
      }
    }
  },
});
